export default __webpack_public_path__ + "static/media/m_8.5fafa062.jpg";